<template>
  <div class="course-box">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>培训任务</el-breadcrumb-item>
    </el-breadcrumb>
    <div>


      <PublicSearch class="user-search" :searchData="searchData"
        @onSearch="() => { pageInfo.currentPage = 1; getData() }">
        <template #clazzName>{{ $store.state.institution }}</template>

        <template #right>
          <el-button v-buttonAuth="'system:trainingPlan:add'" size="small" type="primary" class="mg-btm20"
            @click="handleAction(1)">新增</el-button>
          <el-button v-buttonAuth="'system:trainingPlan:categories'" size="small" type="primary" class="mg-btm20"
            @click="handleAction(7)">任务分类管理</el-button>
        </template>
      </PublicSearch>
    </div>

    <my-table height="80%" :columns="customColumns" :tableData="tableData" :loading="isLoading"
      @selection-change="handleSelectionChange" @row-click="handleRowClick">

      <template #deptNames="item">{{ item.row.deptNames ? item.row.deptNames.toString() : '无' }}</template>

      <template #plannerUser="item">{{ item.row.plannerUser ? item.row.plannerUser.userName : '无' }}</template>

      <template #publishSign="item">{{ item.row.publishSign ? '已发布' : '未发布' }}</template>
      <el-table-column prop="userSex" width="250" label="操作">

        <template slot-scope="scope">
          <div class="d-flex fz14 col-29f cs-pit">
            <div v-if="!scope.row.publishSign" class="operate" @click="handleAction(1, scope)">
              <span v-buttonAuth="'system:trainingPlan:edit'">编辑</span>
            </div>
            <div v-if="!scope.row.publishSign" class="operate" @click="handleAction(2, scope)">
              <span v-buttonAuth="'system:trainingPlan:release'">发布</span>
            </div>
            <div v-buttonAuth="'system:trainingPlan:view'" class="operate" @click="handleAction(3, scope)">查看</div>
            <div v-if="scope.row.completeSign !== 'unPublish'" class="operate" @click="handleAction(4, scope)">
              <span v-buttonAuth="'system:trainingPlan:Trainers'">培训人员</span>
            </div>
            <div class="operate" @click="handleAction(5, scope)">
              <span v-buttonAuth="'system:trainingPlan:recordList'">培训记录表</span>
            </div>
            <div class="operate" v-if="scope.row.publishSign" @click="handleAction(6, scope)">
              <span v-buttonAuth="'system:trainingPlan:evaluation'">有效性评估</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </my-table>
    <div class="main-pagination">
      <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
    </div>
    <!-- 编辑界面 -->
    <el-dialog :title="dialogData.title" :visible.sync="dialogData.visible" :close-on-click-modal="false" width="50%"
      @close="closeDialog()">
      <div class="view-list" v-if="dialogData.title.includes('查看')">
        <div class="view-item" v-for="(item, index) in dialogData.viewList" :key="index">
          <div class="view-label line-ht">{{ item.label }}：</div>
          <div class="flex-1 line-ht">
            <div v-if="item.prop === 'deptNames'" class="">{{ dialogData.viewForm[item.prop].toString() }}</div>
            <div v-else-if="item.prop === 'traineeNames'" class="">{{ dialogData.viewForm[item.prop].toString() }}</div>
            <div v-else-if="item.prop === 'courseList'" class="">
              {{ dialogData.viewForm[item.prop].map(res => res.courseName).toString() }}
            </div>
            <div v-else-if="item.prop === 'plannerUser'" class="">
              {{ dialogData.viewForm[item.prop] ? dialogData.viewForm[item.prop].userName : '' }}
            </div>
            <div v-else-if="item.prop === 'ifCheck'" class="">
              {{ dialogData.viewForm[item.prop] ? '是' : '否' }}
            </div>
            <div v-else>{{ dialogData.viewForm[item.prop] || '无' }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <my-form ref="editForm" :form-config="dialogData.commonList" :dataForm="dialogData.form"
          :formRules="dialogData.rules">
          <template #trainee>
            <div>已选择：{{ dialogSelectData.beforeType == dialogData.form.traineeType ? dialogData.selectTraineeLabel : '-'
              }}
            </div>
            <el-button type="primary" @click="showSelectDialog()">添加培训{{ dialogData.form.traineeType === 'dept' ? '部门' :
              '人员' }}</el-button>
          </template>
        </my-form>
        <div slot="footer" class="dialog-footer text-rgt">
          <el-button size="small" @click='closeDialog()'>取消</el-button>
          <el-button size="small" type="primary" :loading="dialogData.loading" @click="submitForm()">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 全选内容 -->
    <myTransfer :traineeType="dialogData.form.traineeType" :dialogSelectData="dialogSelectData"
      @confirmSelect="confirmSelect" @cancel="dialogSelectData.visible = false;">
    </myTransfer>
    <el-dialog title="有效性评估" :visible.sync="evaluationDialog.visible" :close-on-click-modal="false" width="50%">
      <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="evaluationDialog.textarea">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="evaluationDialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEvaluation()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import PublicSearch from '@/components/publicSearch.vue';
import MyUpload from '@/components/myUpload.vue';
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myTransfer from '@/components/myTransfer';
import myForm from '@/components/myForm.vue';
import api from '../../../api/onlineTraining/trainingPlan';
import { exportWord, getBase64Sync } from '@/utils/exportDocx';
import courseApi from '../../../api/onlineTraining/course';
import { fileDownload } from '../../../utils/util';
import { deptTree, deptList } from '../../../api/dept';
import { archiveList } from '../../../api/employee';
import { examPaperList } from '../../../api/exam';
import { taskTypeList } from '@/api/taskType';
export default {
  components: {
    PublicSearch,
    MyUpload,
    MyTable,
    Pagination,
    myForm,
    myTransfer
  },
  data () {
    return {
      searchData: {
        inputList: [
          { label: '所属机构：', prop: 'clazzName' },
          // {
          //   label: '适用部门',
          //   prop: 'deptIds',
          //   props: 'dept',
          //   type: 'caScaDer',
          //   ref: 'casCaDerOne',
          //   options: [],
          //   casCaDerProps: { label: 'deptName', value: 'deptId', checkStrictly: true, multiple: true, Show: false, emitPath: false }
          // },
          { label: '任务名称：', prop: 'planName', type: 'input', placeholder: '请输入任务名称' },
          { label: '计划人：', prop: 'plannerUserName', type: 'input', placeholder: '请输入计划人' },
          { label: '发布状态：', prop: 'publishSign', type: 'select', placeholder: '请选择发布状态', dictionary: [] },
          { label: '完成状态：', prop: 'completeSign', type: 'select', placeholder: '请选择状态', dictionary: [] },
          { label: '年度：', prop: 'year', type: 'select', placeholder: '请选择年度', dictionary: [] },
          {
            label: '任务类别', prop: 'planCategory', type: 'select', placeholder: '请选择计划类别', dictionary: [
              { label: '三级培训', id: 'level3' },
              { label: '转岗培训', id: 'convert' },
              { label: '日常培训', id: 'daily' },
            ]
          },
          {
            label: '所属部门',
            prop: 'plannerDeptId',
            props: 'dept',
            type: 'caScaDer',
            ref: 'casCaDerOne',
            options: [],
            casCaDerProps: { label: 'deptName', value: 'deptId', checkStrictly: true, Show: false, emitPath: false }
          },
        ],
        searchQuery: { selectSign: '' } //  搜索参数
      }, //  搜索参数
      customColumns: [
        { label: '所属机构', prop: '', formatter: () => { return this.$store.state.institution } },
        // { label: '适用部门', prop: 'deptNames', slot: 'deptNames' },
        { label: '编码', prop: 'planCode' },
        { label: '任务名称', prop: 'planName' },
        { label: '任务类别', prop: 'planCategoryText' },
        { label: '所属级别', prop: 'levelText' },
        { label: '年度', prop: 'year' },
        { label: '制定日期', prop: 'formulateDate' },
        { label: '预计实施日期', prop: 'implementDate' },
        { label: '计划人', prop: 'plannerUser', slot: 'plannerUser' },
        { label: '计划人所属部门', prop: 'plannerDeptName' },
        { label: '培训讲师', prop: 'trainingInstructor' },
        {
          label: '要求完成日期', prop: 'completeDate', formatter: (res, row) => {
            if (row.readSign) {
              return `<span style="color:#D9001B">${res}</span>`
            } else {
              return row.completeDate;
            }
          }
        },
        { label: '发布时间', prop: 'publishTime' },
        {
          label: '完成状态', prop: 'completeSignText', formatter: (res, row) => {
            if (row.readSign) {
              return `<span style="color:#D9001B">${res}</span>`
            } else {
              return res;
            }
          },
        }
      ],
      isLoading: false,
      tableData: [],
      pageInfo: { currentPage: 1, pageSize: 10, total: 0 }, //  分页参数
      dialogData: {
        title: '',
        visible: false,
        loading: false,
        commonList: [
          { type: 'input', prop: 'planName', label: '任务名称', placeholder: '请输入任务名称', span: 12 },
          { type: 'select', prop: 'year', label: '年度', options: [], span: 12 },
          { type: 'select', prop: 'month', label: '月份:', options: [], span: 12 },
          // { type: 'select', prop: 'quarter', label: '季度', options: [], span: 12 },
          {
            type: 'select', prop: 'taskTypeId', label: '任务分类:', options: [

            ], span: 12
          },
          {
            type: 'cascader',
            prop: 'hostDeptId',
            label: '主办部门',
            options: [],
            span: 12,
            property: {
              clearable: true,
              filterable: true,
              'show-all-levels': false,
              props: { label: 'deptName', value: 'deptId', checkStrictly: true, emitPath: false }
            }
          },
          {
            type: 'select', prop: 'ifCheck', label: '是否考核:', options: [
              {
                id: true,
                label: '是'
              },
              {
                id: false,
                label: '否'
              }
            ], span: 12
          },
          {
            type: 'select', prop: 'planCategory', label: '任务类别', placeholder: '请选择任务类别', options: [
              { label: '三级培训', id: 'level3' },
              { label: '转岗培训', id: 'convert' },
              { label: '日常培训', id: 'daily' },
            ], span: 12
          },
          {
            type: 'select', prop: 'level', label: '所属级别', hide: true, placeholder: '请选择所属级别', options: [
              { label: '公司级', id: 'company' },
              { label: '库（站）级', id: 'workshop' },
              { label: '班组级', id: 'unit' },
            ], span: 12
          },

          {
            type: 'select', prop: 'courseIds', label: '培训课程', options: [],
            property: {
              multiple: true
            }
          },
          { type: 'select', prop: 'examPaperId', label: '绑定试卷', placeholder: '请选择试卷', options: [] },

          { type: 'date', prop: 'formulateDate', label: '制定日期', span: 12 },
          { type: 'date', prop: 'implementDate', label: '预计实施日期', span: 12 },
          { type: 'select', prop: 'plannerData', label: '计划人', options: [], span: 12, valueKey: 'archiveId' },
          { type: 'input', prop: 'plannerDeptName', label: '计划人部门', placeholder: '自动获取', disable: true, span: 12 },
          { type: 'textarea', prop: 'planContent', label: '任务内容', placeholder: '请输入内容', maxlength: 500 },
          { type: 'input', prop: 'trainingInstructor', label: '培训讲师', placeholder: '请输入培训讲师', span: 12 },
          { type: 'input', prop: 'trainingUnit', label: '培训单位', placeholder: '请输入培训单位', span: 12 },
          { type: 'date', prop: 'completeDate', label: '要求完成日期' },
          { type: 'radio', prop: 'traineeType', label: '培训人员', options: [] },
          {}
        ],
        commonUser: {
          prop: 'trainee', label: '', options: [], valueKey: 'archiveId',
          property: {
            multiple: true
          }
        },
        commonDept: {
          prop: 'trainee',
          label: '',
          options: [],
          property: {
            clearable: true,
            filterable: true,
            'show-all-levels': false,
            props: {
              label: 'deptName', value: 'deptId', checkStrictly: true, emitPath: false,
              multiple: true
            }
          },
        },
        form: { trainee: [] },
        rules: {
          planName: { required: true, message: '请输入任务名称', trigger: 'blur' },
          planContent: { required: true, message: '请输入任务名称', trigger: 'blur' },
          year: { required: true, message: '请选择年度', trigger: 'change' },
          month: { required: true, message: '请选择月份', trigger: 'change' },
          quarter: { required: true, message: '请选择季度', trigger: 'change' },
          // examPaperId: { required: true, message: '请选择试卷', trigger: 'change' },
          level: { required: true, message: '请选择所属级别', trigger: 'change' },
          planCategory: { required: true, message: '请选择任务类别', trigger: 'change' },
          hostDeptId: { required: true, message: '请选择主办部门', trigger: 'change' },
          ifCheck: { required: true, message: '请选择是否考核', trigger: 'change' },
          taskTypeId: { required: true, message: '请选择任务分类', trigger: 'change' },
          courseIds: { required: true, message: '请选择培训课程', trigger: 'change' },
          traineeType: { required: true, message: '请选择', trigger: 'change' },
          trainee: { required: true, message: '请选择', trigger: 'change' },
          plannerData: { required: true, message: '请选择计划人', trigger: 'change' },
          plannerDeptName: { required: true, message: '请选择计划人部门', trigger: 'change' },
        },
        viewList: [
          { label: '任务名称', prop: 'planName' },
          { label: '年度', prop: 'year' },
          { label: '月份', prop: 'month' },

          { label: '任务分类', prop: 'taskTypeText' },
          { label: '主办部门', prop: 'hostDeptName' },
          { label: '是否考核', prop: 'ifCheck' },

          { label: '任务类别', prop: 'planCategoryText' },
          { label: '所属级别', prop: 'levelText' },

          // { label: '适用部门', prop: 'deptNames' },
          { label: '培训课程', prop: 'courseList' },
          { label: '绑定试卷', prop: 'examPaperName' },
          { label: '制定日期', prop: 'formulateDate' },
          { label: '预计实施日期', prop: 'implementDate' },
          { label: '计划人', prop: 'plannerUser' },
          { label: '计划人部门', prop: 'plannerDeptName' },
          { label: '计划内容', prop: 'planContent' },
          { label: '培训讲师', prop: 'trainingInstructor' },
          { label: '培训单位', prop: 'trainingUnit' },
          { label: '要求完成日期', prop: 'completeDate' },
          { label: '培训人员类型', prop: 'traineeTypeText' },
          { label: '培训人员', prop: 'traineeNames' },
        ],
        selectTraineeLabel: '',
        viewForm: {} //  查看数据
      }, //  弹窗
      URL: envConfig.NODE_IMG_API,
      dialogSelectData: {
        visible: false,
        data: [],
        beforeType: '',
        selectVal: []

      },
      commonAllDept: [],
      evaluationDialog: {
        visible: false,
        textarea: '',
        planId: null
      }
    }
  },
  created () {
    this.$set(this.searchData.searchQuery, 'planName', this.$route.query.planName || '')
    this.getDictionary();
    this.getData();
  },
  methods: {
    fileDownload,
    async getDictionary () {
      const taskTypeRes = await taskTypeList({ stateSign: true });
      this.dialogData.commonList[3].options = taskTypeRes.data.map(item => {
        return { ...item, label: item.taskTypeText, id: item.taskTypeId };
      });

      const commonList = this.dialogData.commonList;
      const inputList = this.searchData.inputList;
      const res = await deptTree();
      inputList[7].options = this.dialogData.commonDept.options = res.data;
      this.dialogData.commonDept.options = res.data;
      commonList[4].options = res.data;
      commonList[2].options = [
        { label: '第一季度', id: 'first' },
        { label: '第二季度', id: 'second' },
        { label: '第三季度', id: 'third' },
        { label: '第四季度', id: 'fourth' }
      ]
      const allDept = await deptList({
        "pageNum": 1,
        "pageSize": 9999
      })
      this.commonAllDept = allDept.data;
      const courseRes = await courseApi.courseList({ publishSign: true });
      commonList[8].options = courseRes.data.map(item => {
        return { ...item, label: item.courseName, id: item.courseId };
      })
      const examPaperRes = await examPaperList({ publishStatus: true });
      commonList[9].options = examPaperRes.data.map(item => {
        return Object.assign(item, { label: item.examName, id: item.examPaperId });
      })
      const archiveRes = await archiveList({});
      commonList[12].options = archiveRes.data.map(item => {
        return { ...item, label: item.userName, id: item };
      })
      this.dialogData.commonUser.options = archiveRes.data.map(item => {
        return { ...item, label: item.userName, id: item.archiveId };
      })
      commonList[18].options = [{ label: '指定人员培训', id: 'user' }, { label: '指定部门培训', id: 'dept' }]
      inputList[3].dictionary = [{ label: '已发布', id: true }, { label: '未发布', id: false }];
      inputList[4].dictionary = [
        { label: '未发布', id: 'unPublish' },
        { label: '进行中', id: 'ing' },
        { label: '已完成', id: 'pass' }
      ];
      const year = new Date().getFullYear();
      const yearList = [];
      for (let i = year - 5; i <= year + 5; i++) {
        yearList.push({ label: i, id: i });
      }
      inputList[5].dictionary = commonList[1].options = yearList || [];
      commonList[2].options = [
        {
          label: '1月',
          id: 1,
        },
        {
          label: '2月',
          id: 2,
        },
        {
          label: '3月',
          id: 3,
        },
        {
          label: '4月',
          id: 4,
        },
        {
          label: '5月',
          id: 5,
        },
        {
          label: '6月',
          id: 6,
        },
        {
          label: '7月',
          id: 7,
        },
        {
          label: '8月',
          id: 8,
        },
        {
          label: '9月',
          id: 9,
        },
        {
          label: '10月',
          id: 10,
        },
        {
          label: '11月',
          id: 11,
        },
        {
          label: '12月',
          id: 12,
        },
      ]
    },
    //  改变分页及大小
    callFather (data) {
      console.log(data);
      this.pageInfo.currentPage = data.currentPage;
      this.pageInfo.pageSize = data.pageSize;
      this.getData();
    },
    //  获取数据
    async getData () {
      const params = {
        pageNum: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize
      };
      const res = await api.planPage({ ...this.searchData.searchQuery, ...params });
      this.tableData = res.data.records;
      this.pageInfo.total = res.data.total;
    },
    async handleAction (index, data) {
      switch (index) {
        case 1:
          if (data) {
            const newData = JSON.parse(JSON.stringify(data.row));
            this.$set(this.dialogData, 'form', { ...newData, plannerData: newData.plannerUser })
            this.dialogData.form.trainee = newData.trainee;
            this.dialogSelectData.beforeType = newData.traineeType;
            this.dialogData.selectTraineeLabel = newData.traineeNames.toString();
          } else {
            this.dialogData.form = { traineeType: 'user' };
            this.dialogData.selectTraineeLabel = '';
            this.dialogSelectData.beforeType = '';
          }
          this.dialogData.title = data ? '编辑' : '添加';
          this.dialogData.visible = true;
          if (this.$refs.editForm) {
            this.$refs.editForm.$refs.form.resetFields();
          }
          setTimeout(() => {
            if (this.dialogData.form.planCategory === 'daily' || !this.dialogData.form.planCategory) {
              this.$set(this.dialogData.rules, 'examPaperId', {})
            } else {
              this.$set(this.dialogData.rules, 'examPaperId', { required: true, message: '请选择试卷', trigger: 'change' })
            }
            this.$refs.editForm.$refs.form.validateField('examPaperId')
          });
          break;
        case 2:
          await api.planPublish({ planId: data.row.planId });
          this.$store.state.importLoading = true;
          const interval = setInterval(async _ => {
            const res = await api.planPublishStatus(data.row.planId);
            if (res.data.passSign) {
              this.$message({
                message: res.data.successSign ? '发布成功' : '发布失败',
                type: res.data.successSign ? 'success' : 'warning'
              });
              this.$store.state.importLoading = false;
              await this.getData();
              clearInterval(interval);
            }
          }, 2000);
          break;
        case 3:
          this.dialogData.title = '查看';
          this.dialogData.viewForm = { ...data.row };
          this.dialogData.visible = true;
          break;
        case 4:
          await this.$router.push({
            path: '/onlineTraining/Trainers',
            query: { planId: data.row.planId, planName: data.row.planName }
          })
          break;
        case 5:
          const res = await api.trainTable(data.row.planId);
          exportWord('/static/trainingRecord.docx', res.data, `${data.row.planName}-培训记录表`, { src: [50, 50] });
          break;
        case 6:
          this.evaluationDialog.textarea = data.row.estimate;
          this.evaluationDialog.planId = data.row.planId;
          this.evaluationDialog.visible = true;
          break;
        case 7:
          this.$router.push({
            path: '/onlineTraining/categories',
          })
          break;
      }
    },
    //  提交
    submitForm () {
      const data = this.dialogData.form;
      const params = { ...data, year: data.year ? data.year.toString() : null, plannerData: null };
      this.$refs.editForm.$refs.form.validate(async valid => {
        if (!valid) return false;
        const url = data.planId ? 'planEdit' : 'planAdd';
        const res = await api[url](params);
        this.$message({ message: data.planId ? '编辑成功' : '添加成功', type: 'success' });
        this.dialogData.visible = false;
        await this.getData();
      });
    },
    handleSelectionChange (selection) {
      console.log('选择发生变化：', selection);
    },
    handleRowClick (row) {
      console.log('点击行：', row);
    },
    showSelectDialog () {
      this.dialogSelectData.visible = true;
      if (this.dialogSelectData.beforeType === this.dialogData.form.traineeType) {
        this.dialogSelectData.selectVal = this.dialogData.form.trainee;
      } else {
        this.dialogSelectData.selectVal = []
      }
      this.dialogSelectData.beforeType = this.dialogData.form.traineeType;
    },
    // 确认选择
    confirmSelect (selectVal, selectTraineeLabel) {
      this.dialogData.selectTraineeLabel = selectTraineeLabel;
      this.$set(this.dialogData.form, 'trainee', selectVal)
      this.dialogSelectData.visible = false;
      this.$refs.editForm.$refs.form.validateField('trainee')
    },
    closeDialog () {
      this.$refs.editForm.$refs.form.resetFields();
      this.dialogData.form = { trainee: [] };
      this.dialogData.visible = false;

    },
    confirmEvaluation () {
      if (!this.evaluationDialog.textarea) {
        this.$message({
          message: '请填写有效性评估',
          type: 'warning'
        });
        return;
      }
      api.editEstimate({ planId: this.evaluationDialog.planId, estimate: this.evaluationDialog.textarea }).then(res => {
        this.$message({
          message: '提交成功',
          type: 'success'
        });
        this.evaluationDialog.visible = false;
        this.getData()
      });
    }
  },
  watch: {
    'dialogData.form.plannerData' (i) {
      if (i) {
        this.dialogData.form = Object.assign(this.dialogData.form, {
          plannerUserId: i.archiveId,
          plannerDeptId: i.deptId,
          plannerDeptName: i.deptName
        })
      } else {
        this.dialogData.form = Object.assign(this.dialogData.form, {
          plannerUserId: null,
          plannerDeptId: null,
          plannerDeptName: null
        })
      }
    },
    'dialogData.form.traineeType' (i, j) {
      if (j && this.dialogData.form.planId) {
        this.dialogData.form.trainee = [];
        this.dialogData.selectTraineeLabel = '';
      }
      if (i === 'dept') {
        this.dialogData.commonList[19] = this.dialogData.commonDept;
      } else {
        this.dialogData.commonList[19] = this.dialogData.commonUser;
      }
    },
    'dialogData.form.planCategory' (i, j) {
      if (i === 'daily') {
        this.$set(this.dialogData.rules, 'examPaperId', {})
      } else {
        this.$set(this.dialogData.rules, 'examPaperId', { required: true, message: '请选择试卷', trigger: 'change' })
      }
      if (this.$refs.editForm) {
        this.$refs.editForm.$refs.form.validateField('examPaperId')
      }
      if (i === 'level3') {
        this.dialogData.commonList[7].hide = false;;
      } else {
        this.dialogData.commonList[7].hide = true;;
      }
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.course-box {
  height: 100%;
  display: flex;
  flex-direction: column;

  .user-search {
    margin-top: 20px;
  }

  .operate {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }

  .view-list {
    width: 70%;
    margin: 0 auto;
    font-size: 16px;

    .view-item {
      display: flex;
      align-items: flex-start;
      padding: 5px 0;

      .view-label {
        width: 150px;
        text-align: right;
      }
    }
  }
}
</style>

<style lang="scss">
.el-loading-mask {
  z-index: 5000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/onlineTraining/trainingPlan/trainingPlan.vue